/**
 * File that can be loaded in each page as a mixin, handles generic stuff for contacts functions
 */
import { Keycloak as backendKeycloakAPI} from "@/api/data";

export const displayNameMixin = {
    methods: {
        getDisplayNameFromObjectProperty(property) {
            property = property.toLowerCase();

            let returnProperty = null;

            switch (property) {
                case "usedefault":
                    returnProperty = "Standaard instelling";
                    break;
                case "node":
                    returnProperty = "Aansluitnummer";
                    break;
                case "messagetypes":
                    returnProperty = "Berichtsoorten";
                    break;
                case "baseurl":
                    returnProperty = "Standaard-URL";
                    break;
                case "description":
                    returnProperty = "Omschrijving";
                    break;
                case "evaluatedby":
                    returnProperty = "Geëvalueerd door";
                    break;
                case "firstname":
                    returnProperty = "Voornaam";
                    break;
                case "functionality":
                    returnProperty = "Functionaliteit HDN platform";
                    break;
                case "insertedby":
                    returnProperty = "Toegevoegd door";
                    break;
                case "isdisabled":
                    returnProperty = "Status";
                    break;
                case "lastname":
                    returnProperty = "Achternaam";
                    break;
                case "maintenance":
                    returnProperty = "Onderhoud HDN platform";
                    break;
                case "malfunctions":
                    returnProperty = "Storingen";
                    break;
                case "member":
                    returnProperty = "Organisatie";
                    break;
                case "name":
                    returnProperty = "Naam";
                    break;
                case "redirecturis":
                    returnProperty = "Redirect-URI's"
                    break;
                case "rooturl":
                    returnProperty = "Root-URL"
                    break;
                case "telephone":
                    returnProperty = "Telefoonnummer";
                    break;
                case "applicationname":
                    returnProperty = "Applicatienaam";
                    break;
                case "authenticationmethod":
                    returnProperty = "Authenticatiemethode";
                    break;
                case "authorizedmember":
                    returnProperty = "Gemachtigde organisatie";
                    break;
                case "applicationdescription":
                    returnProperty = "Applicatie-omschrijving";
                    break;
                case "functionalityname":
                    returnProperty = "Functionaliteitautorisatienaam";
                    break;
                case "functionalitydescription":
                    returnProperty = "Functionaliteitautorisatie-omschrijving";
                    break;
                case "contactreason":
                    returnProperty = "Contactoptie";
                    break;
                case "isempowerable":
                    returnProperty = "Machtigbaar";
                    break;
                case "isrole":
                    returnProperty = "Koppelbaar";
                    break;
                case "receivercodes":
                    returnProperty = "Ontvangercodes";
                    break;
                case "kvknumber":
                    returnProperty = "KVK-nummer";
                    break;
                case "afmnumber":
                    returnProperty = "AFM-nummer";
                    break;
                case "contactreasons":
                    returnProperty = "Contactpersoon voor";
                    break;
                case "nodesallowed":
                    returnProperty = "Aansluitnummers toegestaan";
                    break;
                case "issaasprovider":
                    returnProperty = "Softwareleverancier";
                    break;
                case "useinvoice":
                    returnProperty = "Betalen via factuur";
                    break;
                case "address":
                    returnProperty = "Adres";
                    break;
                case "postalcode":
                    returnProperty = "Postcode";
                    break;
                case "city":
                    returnProperty = "Plaats";
                    break;
                default:
                    /*
                     * Default return property first letter in uppercase
                     */
                    returnProperty = property.charAt(0).toUpperCase() + property.slice(1);
            }

            return returnProperty;
        },
        /**
         * This function fills this.usernames based on the current and new object. It requests names of
         * users from Keycloak via the hdn-usermanagement-service if necessary.
         */
        async getUsernamesFromObjects(currentObject) {
            let users = {};

            /**
             * A Set object contains only unique values, by spreading the Set object into an array,
             * we get an array with unique values.
             *
             * Because of complexity/genericity, even the name of the user of which we have a token
             * is requested.
             */
            let uuids = [...new Set([...this.getUuidsFromObject(currentObject)])];

            if(uuids.length > 0) {
                users = {...users, ...await backendKeycloakAPI.getKeycloakUsernamesByUUID(uuids)};
            }

            return users;
        },
        /**
         * This function gets the objects that are used in the change dialogue and
         * takes out the UUIDs in the fields insertedBy and evaluatedBy.
         *
         * It returns an array of UUIDs to request the name for from Keycloak.
         */
        getUuidsFromObject(obj) {
            let uuids = [];
            if(obj.insertedBy) {
                uuids.push(obj.insertedBy);
            }

            if(obj.evaluatedBy) {
                uuids.push(obj.evaluatedBy);
            }
            
            return uuids;
        },
        /**
         * Used when creating the page content to show the user that inserted or
         * evaluated the change, rather than the user's UUID.
         *
         * In case the property is not evaluatedBy or insertedBy, the normal value
         * is returned as no other fields have UUIDs at the moment.
         *
         * In case the property is evaluatedBy or insertedBy, it checks whether a
         * name for the user is known. If so, it replaces the UUID with the user's name.
         * If no name is known, the UUID is shown anyway.
         */
        getDisplayText(value, property) {
            if(property === "evaluatedBy" || property === "insertedBy") {

                /**
                 * Backend returns an empty string in case Keycloak does not
                 * know any user with the requested UUID. So if
                 * this.usernames[value] === "", we should also return the UUID.
                 */
                if(this.usernames[value] && this.usernames[value] !== "") {
                    return this.usernames[value];
                }
            }

            return value;
        }
    }
}